import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import ClassTable from './table/js/classTable';
import ClassCreate from './create/js/classCreate';

export default function ClassesManagement() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="eduss-student-management">
      <div className="eduss-student-management-content">
        <ClassTable reloadKey={reloadKey} onCreate={() => setShowCreateModal(true)} />
      </div>

      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Class</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <ClassCreate onClose={() => setShowCreateModal(false)} onSubmit={() => { setReloadKey(k => k + 1); setShowCreateModal(false); }} />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
